export default __webpack_public_path__ + "static/media/01.6cc21b6c.jpg";